const NAVY_MID = '#132233';
const WHITE    = '#FFFFFF';
const AMBER    = '#F5A623';
const FONT_BODY = "'DM Sans', sans-serif";

// Shared stat-card shell used across every dashboard (Organization, Admin, Employer, Union).
// Previously each dashboard hand-rolled its own near-identical version -- one had an unused
// `trend` prop, one had no icon at all, one had hardcoded fake trend text instead of a real
// computed value. This is the single implementation all of them should render through.
export default function StatCard({ label, value, Icon, iconColor = AMBER, valueColor = WHITE, trend, trendColor, onClick }) {
  const clickable = !!onClick;
  return (
    <div
      onClick={onClick}
      onMouseEnter={clickable ? e => { e.currentTarget.style.backgroundColor = '#1A2C40'; } : undefined}
      onMouseLeave={clickable ? e => { e.currentTarget.style.backgroundColor = NAVY_MID; } : undefined}
      style={{
        backgroundColor: NAVY_MID, borderRadius: '12px', padding: '16px 18px',
        cursor: clickable ? 'pointer' : 'default', transition: clickable ? 'background-color 0.15s' : undefined,
        fontFamily: FONT_BODY,
      }}
    >
      {Icon && (
        <div style={{ marginBottom: '10px' }}>
          <Icon color={iconColor} />
        </div>
      )}
      <p style={{ fontSize: '0.68rem', fontWeight: 700, color: 'rgba(255,255,255,0.38)', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '8px' }}>
        {label}
      </p>
      <p style={{ fontSize: '2rem', fontWeight: 700, color: valueColor, lineHeight: 1 }}>{value}</p>
      {trend && (
        <p style={{ fontSize: '0.78rem', color: trendColor || iconColor, marginTop: '7px', fontWeight: 600 }}>
          {trend}
        </p>
      )}
    </div>
  );
}
